import {FormResponseStatuses} from "../../../../packages/biz-form/core/constants/form-response-statuses";

/**
 * Formats the form response status label for display. If the status is null or undefined, it returns an empty string. Otherwise, it returns the status as is.
 * @param status
 */
export function formatFormResponseStatusLabel(status?: string | null): string {
    if (!status) {
        return "";
    }
    return status;
}

/**
 * Gets the color associated with the form response status. Approved status maps to "success", Pending maps to "warning", Declined maps to "error", and any other status (including null or undefined) maps to "default".
 * @param status
 */
export function getFormResponseStatusColor(status?: string | null): "default" | "success" | "warning" | "error" {
    switch (status) {
        case FormResponseStatuses.Approved:
            return "success";
        case FormResponseStatuses.Pending:
            return "warning";
        case FormResponseStatuses.Declined:
            return "error";
        default:
            return "default";
    }
}
